export default __webpack_public_path__ + "static/media/airplane_menu_icon.84791003.svg";